module.exports = __webpack_public_path__ + "img/face1.9ad1d6fc.jpg";